import React from 'react';
import { Container, Card } from 'react-bootstrap';
import './PolitiqueCookies.css';

const PolitiqueCookies = () => {
  return (
    <Container className="my-5">
      <Card className="p-4 shadow-sm">
        <Card.Body>
          <Card.Title as="h1" className="text-center mb-4">Politique de gestion des cookies</Card.Title>

          <p>Cette politique de cookies explique ce que sont les cookies et comment nous les utilisons sur le site Renovestim.</p>

          <h2 className="mt-4">Qu'est-ce qu'un cookie ?</h2>
          <p>
            Un cookie est un petit fichier texte stocké sur votre ordinateur ou appareil mobile par un site web que vous visitez. Il permet au site de se souvenir de vos actions et préférences (telles que la connexion, la langue, la taille de la police et d'autres préférences d'affichage) sur une période donnée, afin que vous n'ayez pas à les saisir à nouveau chaque fois que vous revenez sur le site ou naviguez d'une page à une autre.
          </p>

          <h2 className="mt-4">Comment utilisons-nous les cookies ?</h2>
          <p>Nous utilisons des cookies pour plusieurs raisons :</p>
          <ul>
            <li><strong>Cookies strictement nécessaires :</strong> Ces cookies sont essentiels pour vous permettre de naviguer sur le site et d'utiliser ses fonctionnalités, comme l'accès à des zones sécurisées. Sans ces cookies, les services que vous avez demandés, comme la connexion à votre compte, ne peuvent pas être fournis.</li>
            <li><strong>Cookies de performance et d'analyse :</strong> Ces cookies collectent des informations sur la manière dont les visiteurs utilisent notre site, par exemple les pages les plus visitées. Nous utilisons ces données pour optimiser notre site web et améliorer l'expérience utilisateur. Nous utilisons Google Analytics à cette fin.</li>
            <li><strong>Cookies de fonctionnalité :</strong> Ces cookies permettent au site de se souvenir des choix que vous faites (comme votre nom d'utilisateur ou la région où vous vous trouvez) et de fournir des fonctionnalités améliorées et plus personnelles.</li>
          </ul>

          <h2 className="mt-4">Services tiers</h2>
          <p>
            Nous utilisons des services tiers comme Google Analytics et Stripe, qui peuvent également installer des cookies sur votre appareil pour assurer le bon fonctionnement de leurs services. Nous ne contrôlons pas l'utilisation de ces cookies tiers et nous vous recommandons de consulter les politiques de confidentialité de ces services pour plus d'informations.
          </p>

          <h2 className="mt-4">Comment contrôler les cookies ?</h2>
          <p>
            Vous pouvez contrôler et/ou supprimer les cookies comme vous le souhaitez. Pour plus de détails, consultez <a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer">aboutcookies.org</a>.
          </p>
          <p>
            Vous pouvez supprimer tous les cookies qui sont déjà sur votre ordinateur et vous pouvez configurer la plupart des navigateurs pour empêcher leur placement. Si vous faites cela, cependant, vous devrez peut-être ajuster manuellement certaines préférences chaque fois que vous visitez un site, et certains services et fonctionnalités peuvent ne pas fonctionner.
          </p>

          <h2 className="mt-4">Mise à jour de notre politique</h2>
          <p>
            Nous pouvons mettre à jour cette politique de cookies de temps à autre. Nous vous encourageons à consulter cette page régulièrement pour prendre connaissance de toute modification.
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PolitiqueCookies;
